import { useInView } from "react-intersection-observer";
import Trailer from "./Trailer";
import TrailerSlider from "./TrailerSlider";

function TrailerSliderInView({ data, headerImage, clName }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    fallbackInView: true,
  });

  return (
    <div ref={ref}>
      {inView ? (
        <TrailerSlider data={data} headerImage={headerImage} clName={clName} />
      ) : null}
    </div>
  );
}
export default TrailerSliderInView;
